import { useEffect } from 'react';
import urlTemplate from 'url-template';
import type { Uuid } from 'src/apis/api-utilities';
import type { NotificationDetailsResponse } from 'src/apis/notification-service/types';
import type { NotificationServiceRequest } from 'src/apis/notification-service/use-notification-service-root';
import type { Successful } from 'src/hooks/use-axios';
import { useAxios } from 'src/hooks/use-axios';

type Props = {
  notificationService: Successful<NotificationServiceRequest>;
  notificationId: Uuid;
};

export function useNotificationDetails({
  notificationService,
  notificationId,
}: Props) {
  const notificationDetails = useAxios(
    (axios, baseConfig, { notificationService, notificationId }: Props) => {
      const url = urlTemplate
        .parse(notificationService.response.data._links.getNotification!.href) // we check for the link in the parent component
        .expand({ notificationId });

      return axios.request<NotificationDetailsResponse>({
        ...baseConfig,
        url,
      });
    },
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    notificationDetails.execute({
      notificationService,
      notificationId,
    });
    // oxlint-disable-next-line exhaustive-deps
  }, [notificationService.response, notificationId]);

  return notificationDetails;
}

export type NotificationDetailsRequest = ReturnType<
  typeof useNotificationDetails
>;
